import { z } from 'zod';

/**
 * The Zod schema for the input of the `webSearch` tool.
 */
export const WebSearchSchema = z.object({
  query: z.string().describe('Search query'),
  numResults: z.number().min(1).max(10).optional().default(5).describe('Number of results to return'),
  type: z
    .enum(['keyword', 'neural', 'auto'])
    .nullish()
    .default('auto')
    .describe('Search type - keyword for exact matches, neural for semantic search'),
  useAutoprompt: z.boolean().optional().default(true).describe('Automatically enhance the query for better results'),
  category: z.enum(['general', 'news', 'papers', 'tweets', 'company']).nullish().describe('Filter results by category'),
});

/**
 * The Zod schema for a single, cleaned search result.
 * @private
 */
export const WebSearchResultSchema = z.object({
  title: z.string(),
  url: z.string().url(),
  snippet: z.string().nullish(),
  publishedDate: z.string().nullish(),
  score: z.number().nullish(), // Make score optional as the API may not always return it
});

/**
 * The Zod schema for the final output of the `webSearch` tool.
 */
export const WebSearchResponseSchema = z.object({ results: z.array(WebSearchResultSchema) });
